/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-11 09:51:03
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-23 16:36:56
 */
//系统日志
import http from '../httpConfig'
const table = "mrbase_sys_log"

// 系统日志列表
export const system_log_list = (params = {}) => {
  params['~table~'] = 'mrbase_sys_log'
  return new Promise((resolve, reject) => {
    http.post('/api/log/list-system-log/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}